import * as css from './SMSCode.css';
import {useEffect} from 'react';
import CodeInput from '../codeInput/CodeInput';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import setGlobalState from '../../redux/setGlobalState';
import {getTime} from '../../library/dates';
import {useTimer} from '../../hooks/useTimer';

export const codeExpiration=3*60;

export const resetCodeInput=()=>{
    setGlobalState('ui.codeInput.reset',true);
};

export const updateExpiredTime=()=>{
    const expiredTime= new Date();
    expiredTime.setSeconds(expiredTime.getSeconds()+codeExpiration);
    setGlobalState('ui.codeInput.expiredTime',expiredTime);
};

function SMSCode({amount = 6, onUpdate, sendAgainClick,address,text,disabled}) {
    const codeInput = useSelector(state => state.ui.codeInput);
    const {isWrong,expiredTime,reset}=codeInput||{};
    const {timer,setTimer}=useTimer(expiredTime?(expiredTime-new Date().getTime())/1000:codeExpiration);

    const {t} = useTranslation('global');
    const phone = useSelector(state => state.user.phone);
    let phoneString = address?address:(phone?('XXX-XXX' +phone?.substr(6, phone.length)):'');

    function resetAll() {
        setTimer(codeExpiration);
        if(isWrong){
            setGlobalState('ui.codeInput.isWrong',false);
        }
        
    }
    
    useEffect(()=>{
        if(reset) 
            resetAll();
        setGlobalState('ui.codeInput.reset',false);
    },[reset]);
    
    useEffect(()=>{
        if(expiredTime)
            setTimer((expiredTime-new Date().getTime())/1000);
    },[expiredTime]);

    const optionClick = (isVoiceCode) => {
        if(disabled)
            return;
        if(sendAgainClick)
            sendAgainClick(isVoiceCode);
        resetAll();
        updateExpiredTime();
    };

    const handleUpdate = (code) => {
        if(timer <= 0) {
            setGlobalState('ui.codeInput.isWrong', true);
            return;
        }
        onUpdate(code);
    };

    return (<>
        <css.container data-cy = 'temporaryCodeMSG' >
            <css.text >{isWrong ? t('wrongCode') : (text||t('SMSSent')) + phoneString} {t('expireCode',{time:getTime(timer)})}</css.text>
            <css.code id='loginPasswordSquares'  data-cy='loginPasswordSquares'>
                <CodeInput amount={amount} onUpdate={handleUpdate} isWrong={isWrong}/>
            </css.code>
            <css.options>
                <css.option disabled={disabled} onClick={() => optionClick()} data-cy= 'tryAgainLogin' className={disabled ? 'disabled' : ''}>{t('sendAgain')}</css.option>
                {/* <css.option onClick={() => optionClick(true)}>{t('voiseCode')}</css.option> */}
            </css.options>
        </css.container>
    </>
    );
}

export default SMSCode;
